/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {sendMRIContext} from '../api'

export const useMutationSendMRIContext = createReactQueryMutationHook('sendMRIContext', sendMRIContext)
